import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
// @ts-ignore
import { Dropdown } from '@els/els-react--dropdown';
// @ts-ignore
import { Paginator } from '@els/els-react--paginator';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
import { generatePath } from 'react-router';
import './skills-favorite-tab.scss';
import { favoriteContentFilterDropdown } from '../../../constants/skills-sort-order';
import { sortDataByAlphabet, sortDataByDate } from '../../../utils/helper';
import SkillsFavoriteList from '../favorite-content-table/favorite-content-list';
import {
    selectfavoriteSkillList,
    selectSkillListCount,
    selectUserFavoriteContentAsyncStatus,
    selectUserFavoriteContentStatusCode,
} from './skills-favorite-tab-selector';
import {
    selectReferentialAccessAsyncStatus,
    selectIsIpWhitelistedAsyncStatus,
} from '../../referential-access/referential-access-selector';
import {
    isPending,
    hasFailed,
    hasSucceeded,
    isComplete,
} from '../../../../libs/utils/constants/async-status';
import { getUserFavoriteContent } from './skills-favorite-tab-thunk';
import ServerErrorPage from '../../../components/server-error-page/server-error-page';
import { ResultsPerPage } from '../../../constants/results-per-page';
import Routes from '../../../constants/routes';
import NoFavorites from '../../../components/no-favorites/no-favorites';

const SkillsFavoriteTab = () => {
    const baseClassName = 'skills-tab';
    const dispatch = useDispatch();
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(1);
    const userFavoriteSkillList = useSelector(selectfavoriteSkillList);
    const userFavoriteContentAsyncStatus = useSelector(
        selectUserFavoriteContentAsyncStatus
    );
    const userFavoriteContentStatusCode = useSelector(
        selectUserFavoriteContentStatusCode
    );
    const userFavoriteContentCount = useSelector(selectSkillListCount);
    const isReferentialAsyncStatus = useSelector(
        selectReferentialAccessAsyncStatus
    );
    const isIpWhitelistedAsyncStatus = useSelector(
        selectIsIpWhitelistedAsyncStatus
    );

    const limit = ResultsPerPage.USER_FAVORITE_CONTENT_VIEW;
    let offset = (currentPage - 1) * limit;
    let sortedFavoriteContent = [];
    const [selectedFilter, setSelectedFilter] = useState(
        favoriteContentFilterDropdown[0].label
    );
    const [selectedSortOrder, setselectedSortOrder] = useState('A to Z');
    const [isSorting, setIsSorting] = useState(false);
    const { ecrId } = useParams<{ ecrId: string }>();

    const handleSkillsSort = (sortOrder: string) => {
        if (sortOrder === 'A to Z' || sortOrder === 'Z to A') {
            return sortDataByAlphabet(userFavoriteSkillList, sortOrder);
        }
        return sortDataByDate(userFavoriteSkillList, sortOrder);
    };

    sortedFavoriteContent = handleSkillsSort(selectedSortOrder);
    let paginatedFavoriteContent = sortedFavoriteContent.slice(
        offset,
        offset + limit
    );
    let startIndex;

    if (currentPage === 1) {
        if (userFavoriteContentCount > 0) {
            startIndex = 1;
        } else {
            startIndex = 0;
        }
    } else {
        startIndex = (currentPage - 1) * limit + 1;
    }
    const endIndex = Math.min(currentPage * limit, userFavoriteContentCount);

    const getSelectedOption = (selectedSortBy: any) => {
        const selectedLabel = selectedSortBy.label;
        const selectedOption = favoriteContentFilterDropdown.find(
            (option: any) => option.label === selectedLabel
        );
        if (selectedOption) {
            const { label, value } = selectedOption;
            setSelectedFilter(label);
            setselectedSortOrder(value);
            setIsSorting(true);
            handleSkillsSort(value);
            setTimeout(() => {
                setIsSorting(false);
            }, 1000);
        }
    };

    const onPageChangeHandler = (value: number): void => {
        setCurrentPage(value);
        offset = (currentPage - 1) * limit;
        paginatedFavoriteContent = sortedFavoriteContent.slice(
            offset,
            offset + limit
        );
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        dispatch(getUserFavoriteContent());
    }, []);

    const handleRedirectToSkillDetail = (courseId: any) => {
        const redirectLink = generatePath(Routes.SKILL_LAUNCH, {
            id: courseId,
            ecrId,
        });
        history.push(`${redirectLink}/`);
        window.scrollTo(0, 0);
    };

    return (
        <div className={`${baseClassName}`}>
            {hasSucceeded(userFavoriteContentAsyncStatus) &&
                userFavoriteContentStatusCode === 204 && (
                    <NoFavorites contentName="skill" />
                )}
            {hasFailed(userFavoriteContentAsyncStatus) &&
                userFavoriteContentStatusCode !== 200 && <ServerErrorPage />}
            {isPending(userFavoriteContentAsyncStatus) &&
                isComplete(isReferentialAsyncStatus) &&
                isComplete(isIpWhitelistedAsyncStatus) && (
                    <Loader
                        isVisible
                        isBlocking={false}
                        className={`${baseClassName}-loader`}
                    />
                )}
            {hasSucceeded(userFavoriteContentAsyncStatus) &&
                userFavoriteContentCount > 0 && (
                    <>
                        <div className={`${baseClassName}__sortBy`}>
                            <span
                                className={`${baseClassName}__sortBy__span-label`}
                            >
                                Sort by:
                            </span>
                            <Dropdown
                                id="dropdown"
                                options={favoriteContentFilterDropdown}
                                label={selectedFilter}
                                className={`${baseClassName}__sortBy-dropdown`}
                                onChange={getSelectedOption}
                                placement="bottom-end"
                                shouldCloseOnESC
                            />
                        </div>
                        <div className={`${baseClassName}__details`}>
                            {`Showing ${startIndex} - ${endIndex} of ${userFavoriteContentCount} ${
                                userFavoriteContentCount !== 1
                                    ? 'Favorites'
                                    : 'Favorite'
                            }`}
                        </div>
                        <div className={`${baseClassName}__skill-warpper`}>
                            <SkillsFavoriteList
                                id="skills-favorite-list"
                                favoriteSkillList={paginatedFavoriteContent}
                                isSorting={isSorting}
                                handleRedirectToSkillDetail={
                                    handleRedirectToSkillDetail
                                }
                            />
                            <div className="pagination-container">
                                <Paginator
                                    a11y={{
                                        name: 'User favorite skills list',
                                        pagingUnitName: 'Page',
                                        morePagingUnit: 'More pages',
                                    }}
                                    shouldShowPrevNextLabel
                                    className="els-pagination"
                                    currentPage={currentPage}
                                    onPageChange={onPageChangeHandler}
                                    resultsPerPage={limit}
                                    maxPagesToShow={10}
                                    totalResults={userFavoriteContentCount}
                                />
                            </div>
                        </div>
                    </>
                )}
        </div>
    );
};
export default SkillsFavoriteTab;
